import { render } from "./EventEditorPreview.vue?vue&type=template&id=720dc250&ts=true"
import script from "./EventEditorPreview.vue?vue&type=script&lang=ts"
export * from "./EventEditorPreview.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__